import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {  GetPostEnquiry } from '../../../_seivices';
import Layout from '../../shared/Layout';
import DataTable from 'react-data-table-component';
import { imagebaseurl } from '../../../_config';

const JobEnquiry = () => {
    const [loading, setLoading] = useState(false);
    const [jobEnquiryData, setJobEnquiryData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const fetchGetPostEnquiry = async () => {
        try {
            const data = await GetPostEnquiry();
            setJobEnquiryData(data);
        } catch (error) {
           return null;
        } finally {
            setLoading(false)
        }
    };

    useEffect(() => {
        fetchGetPostEnquiry();
    }, [])

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleRowsPerPageChange = (newRowsPerPage, page) => {
        setRowsPerPage(newRowsPerPage);
        setCurrentPage(page);
    };

    const columns = [    
        {
            name: 'S.No',
            selector: (row, index) => ((currentPage - 1) * rowsPerPage) + index + 1,
            width: '80px',
            center: true,
            sortable: false
        },
        {
            name: 'Job Title',
            selector: row => row.jobTitle,
            sortable: true
        },
        {
            name: 'Name',
            selector: row => row.firstName + ' ' + row.lastName,
            sortable: true,
            width:"150px"
        },
        {
            name: 'Email Id',
            selector: row => row.emailid,
            sortable: true,
            width:"200px"
        },
        {
            name: 'Contact No',
            selector: row => row.mobileNo,
            sortable: true,
            width:"150px"
        },
        {
            name: 'Current CTC',
            selector: row => row.currentCtc,
            sortable: true,
            width:"150px"
        },
        
        {
            name: 'Expected CTC',
            selector: row => row.expectedCtc,
            sortable: true,
            width:"150px"
        },
        {
            name: 'Notice Period',
            selector: row => row.noticePeriod,
            sortable: true
        },
        {
            name: 'Resume',
            selector: row => (
                <div style={{wordWrap:'normal'}}  >  <Link target='_blank' to={`${imagebaseurl}${row.resumePath}`}> View</Link></div>
            ),
            sortable: true,
             width:'100px',
        },

        {
            name: 'Entry Date',
            selector: row => row.createdDate ? new Date(row.createdDate).toISOString().slice(0, 10) : '',
            sortable: true
        },
    ];

    return (
        <Layout>
            <div className="px-4">
                <div className="admin-page mt-3 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading" style={{ gap: "20px" }}>
                        <h4 className="mb-0">Job Enquiry Detail</h4>
                    </div>
                </div>
            </div>

            <div className="datatable mt-3">
                <DataTable
                    fixedHeader
                    fixedHeaderScrollHeight="calc(100vh - 220px)"
                    columns={columns}
                    data={jobEnquiryData || []}
                    progressPending={loading}
                    progressComponent={<p>Loading...</p>}
                    pagination
                    paginationPerPage={rowsPerPage}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handleRowsPerPageChange}
                    highlightOnHover
                />
            </div>
        </Layout>
    );

};

export default JobEnquiry;

